export const RISK_MATRIX_CONSTANTS = {
  MIN_SIZE: 3,
  MAX_SIZE: 7,
  DEFAULT_ROWS: 5,
  DEFAULT_COLUMNS: 5,
  DEFAULT_IMPACT_LABELS: ['Insignificant', 'Minor', 'Significant', 'Major', 'Severe'] as string[],
  DEFAULT_LIKELIHOOD_LABELS: ['Almost certain', 'Likely', 'Moderate', 'Unlikely', 'Rare'] as string[],
} as const;

import { colors } from 'theme/colors';

export const RISK_COLORS = {
  LOW: colors.ui.risk.low,
  LOW_ALT: colors.ui.risk.lowAlt,
  MEDIUM: colors.ui.risk.medium,
  HIGH: colors.ui.risk.high,
  VERY_HIGH: colors.ui.risk.veryHigh,
} as const;

export const RISK_LABELS = {
  LOW: 'Low',
  MEDIUM: 'Medium',
  HIGH: 'High',
  VERY_HIGH: 'Very high',
  EXTREME: 'Extreme',
} as const;
